import { AfterViewInit, Component, ElementRef, NgZone, OnInit, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType, ClientModel, ClientSettingViewModel, ClientUserViewModel, ClientViewModel, JwTokenModel, ListItem, UserModel } from "../../core/api/models";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { map, tap } from "rxjs/operators";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { ClientsApiService } from "../../core/api/services";
import { Table } from "primeng/table";
import { DomSanitizer } from "@angular/platform-browser";



@Component({
  selector: 'app-client-detail-component',
  templateUrl: './client-detail.component.html',
  styleUrl: './client-detail.component.css',
  standalone: false
})
export class ClientDetailComponent implements OnInit, AfterViewInit {
  

  public pageTitle: string = 'Client';


  @ViewChild('itemForm') itemForm!: NgForm;

  @ViewChild('dt1') table?: Table;
  
  itemFormGroup!: FormGroup;
  currentItem?: ClientSettingViewModel;
  loading: boolean = true;
  clientUsers: Array<ClientUserViewModel> = [];
  cancellationReasons: Array<ListItem> = [];
  insuranceEmployeeBenefits: Array<ListItem> = [];
  serviceSettings: Array<ListItem> = [];

  loadingPicture: boolean = false;


  constructor(private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
    private apiService: ClientsApiService,
    private sanitizer: DomSanitizer,
    private formBuilder: FormBuilder) {
  }


  ngOnInit(): void {


    this.route.paramMap.subscribe((params: ParamMap) => {
      let ID = + (params.get('ID') || '0');

      this.clientUsers = [];
      if (ID > 0) {
       
        this.apiService.GetClientSettings({ body: { clientID: ID } })
        .forEach(data => {
          this.loading = false;
          this.currentItem = data;
          this.load();
          
        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });

        this.apiService.GetClientDetailOptions({  clientID: ID  }).forEach(data => {
          this.loading = false;
          //this.currentItem = data;
          //this.load();
          this.cancellationReasons = data.CancellationReasons ?? [];
          this.insuranceEmployeeBenefits = data.InsuranceEmployeeBenefits ?? [];
          this.serviceSettings = data.ServiceSettings ?? [];

        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });
          
        this.apiService.GetClientUsers({ body: { clientID: ID } }).forEach(data => {
          this.loading = false;
          //this.currentItem = data;
          //this.load();
          this.clientUsers = data;

        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));

          });

        
      }
    });

    this.itemFormGroup = this.formBuilder.group(
      {

        //userId: [],
        BusinessName: ['', [Validators.required, Validators.maxLength(255)]],
        BusinessAbbreviation: ['', [Validators.required, Validators.maxLength(50)]],
        BusinessFullName: ['', [Validators.required, Validators.maxLength(255)]],
        BusinessAddress: ['', [Validators.required, Validators.maxLength(255)]],
        BusinessPhone: ['', [Validators.required, Validators.maxLength(50)]],
        BusinessFax: ['', [Validators.maxLength(50)]],
        AceProviderID: ['', [Validators.maxLength(25)]],
        AceProviderCoordinator: [0, [Validators.maxLength(25)]],
        BusinessWebsite: ['', [Validators.required, Validators.maxLength(512)]],
        StartupGuideOn: [false, []],
        CollectionsWarning: ['', [Validators.maxLength(7000)]],
        BillingSettingsName: ['', [Validators.required, Validators.maxLength(100)]],
        BillingSettingsAddressLine1: ['', [Validators.required, Validators.maxLength(250)]],
        BillingSettingsAddressLine2: ['', [Validators.maxLength(250)]],
        BillingSettingsPhoneNumber: ['', [Validators.required, Validators.maxLength(100)]],
        BillingSettingsFaxNumber: ['', [Validators.maxLength(100)]],
        BillingSettingsEmail: ['', [Validators.required, Validators.maxLength(250), Validators.email]],
        BillingSettingsInvoiceFootnote: ['', [Validators.maxLength(1000)]],
        InHouseFinancing: [false, []],
        InHouseFinancingMessage: ['', []],
        CareCreditVendor: [false, []],
        InvoiceTextReminders: [false, []],
        InvoiceReminderFrequencyDays: ['', [Validators.maxLength(255)]],
        DaysToUnpaidInvoiceServiceInteruption: ['', [Validators.maxLength(255)]],
        DaysToUnPaidServiceStop: ['', [Validators.maxLength(255)]],
        DefaultServiceSettingID: ['', [Validators.maxLength(255)]],
        FromEmailAddress: ['', [Validators.maxLength(255), Validators.email]],
        EmailSettingsDisplayName: ['', [Validators.maxLength(255)]],
        CredentialEmail: ['', [Validators.maxLength(255), Validators.email]],
        BillingEmail: ['', [Validators.maxLength(255), Validators.email]],
        AAEmail: ['', [Validators.maxLength(255), Validators.email]],
        AuthorizationsEmail: ['', [Validators.maxLength(255), Validators.email]],
        OptoMailDomain: ['', [Validators.maxLength(255)]],
        EmailDisplayName: ['', [Validators.maxLength(255)]],
        DaysToFirstScheduleAfterAuth: ['', [Validators.maxLength(3)]],
        DaysAfterIncompleteIntakeBlock: ['', [Validators.maxLength(25)]],
        AccountLockedCancellationReasonID: [0],
        ProfessionalLiabilityNumber: ['', [Validators.maxLength(25)]],
        ProfessionalLiabilityOccurrenceAmount: ['', [Validators.maxLength(25)]],
        ProfessionalLiabilityAggregateAmount: ['', [Validators.maxLength(25)]],
        CompanyNPI: ['', [Validators.maxLength(25)]],
        TaxID: ['', [Validators.maxLength(50)]],
        CompanyPTAN: ['', [Validators.maxLength(50)]],
        CompanyMedicaidNumber: ['', [Validators.maxLength(50)]],
        RequestResignIntakeAfterDays: ['', [Validators.maxLength(50)]],
        IntakeRenewalFrequency: ['', [Validators.maxLength(50)]],
        EmployeeBenefitInsuranceProviderID: [''],
        EmployeeOptomiserLockoutDate: ['', [Validators.maxLength(50)]],
        KeyValues: this.formBuilder.array([])
      });



    this.authService.checkIfAutorized([ArkUserType.Marketing, ArkUserType.Admin, ArkUserType.Impersonator]);
  
  }
  get KeyValues(): FormArray {
    var result = this.itemFormGroup.get('KeyValues') as FormArray;
    return result;
  }

  load() {
    if (!this.currentItem)
      return;
    console.info(this.currentItem);
    if (this.itemForm)
      this.itemForm.resetForm();
    if (this.itemFormGroup)
      this.itemFormGroup.clearValidators();


    this.KeyValues.clear();
    if (this.currentItem.KeyValues)
      this.currentItem.KeyValues.forEach(t => {
        var item: FormGroup = this.newKeyValues();
        this.KeyValues.push(item);
      });

    this.itemFormGroup.patchValue(this.currentItem);


  }


  newKeyValues() {
    return this.formBuilder.group({
      DataTypeID: [''],
      Description: [''],
      FeatureID: [''],
      KeyID: [''],
      KeyName: [''],
      Value: ['', [Validators.maxLength(4000)]],
    });
  }

  ngAfterViewInit(): void {


  }



  save() {

    if (!this.itemFormGroup.valid) {

      const errors = Utils.getFormErrors(this.itemFormGroup);

      if (errors.length > 0) {
        this.alertService.error(errors.join(' \n'));
        return;
      }
    }
    var formValue = this.itemFormGroup.getRawValue();


    let newItem =
    {
      ...this.currentItem,
      ...formValue
    }
    console.info(newItem);


    this.loading = true;
    this.apiService.SaveClientSettings({ body: newItem })
      .forEach(
        (savedItem) => {

          this.loading = false;
          this.currentItem = undefined;
          if (this.itemForm)
            this.itemForm.resetForm();
          this.alertService.success('Item saved successfully');
          this.router.navigate([`/clients`]);
        }).catch(
          (err) => {
            this.loading = false;
            this.alertService.error(Utils.getAjaxError(err));
          });


  }

  getClientLogo(client: ClientSettingViewModel | ClientModel | null | undefined, type: string = 'Print'): any {

    var siteName = client?.SiteName?.toLocaleLowerCase();
    if (siteName == 'optodev' || siteName == 'utbs')
      siteName = 'beta';
    
    //return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/DisplayLogo/${siteName}.png`);
    return this.sanitizer.bypassSecurityTrustUrl(`https://${siteName}.${environment.baseDomain}/Login/${type}Logo/${siteName}.png`);
  }

  uploadPicture(fileInput: any, logo: string) {
    if (fileInput && fileInput.files && fileInput.files.length > 0) {
      this.loadingPicture = true;
      this.apiService.UploadLogoImage({
        clientID: this.currentItem?.ClientID ?? 0,
        logo: logo,
        body: {
          file: fileInput.files[0]
        }
      }).forEach(
        () => {
          this.alertService.info(logo + ' picture updated successfully');
          
          this.loadingPicture = false;


        }).catch(
          err => {
            this.alertService.error(Utils.getAjaxError(err));
            this.loadingPicture = false;
          }).
        finally(() => {
          this.loadingPicture = false;
        });
    }
  }

}
